import { downloadBlob } from '@src/common/utils/downloadBlob';

export const DownloadService = {
  download: async (blob: Blob, fileName: string) => {
    if ('showSaveFilePicker' in window) {
      return saveBlobToFile(blob, fileName);
    }
    downloadBlob(blob, fileName);
  },

  openInNewTab: async (blob: Blob) => {
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  },
};

async function saveBlobToFile(blob: Blob, fileName: string) {
  try {
    const handle = await window.showSaveFilePicker({
      suggestedName: fileName,
      types: [
        {
          description: 'Files',
          accept: { '*/*': ['.pdf'] },
        },
      ],
    });

    const writable = await handle.createWritable();
    await writable.write(blob);
    await writable.close();
  } catch {
    // noop
  }
}
